// 由一个组件，向上找到最近的指定组件
export default function findComponentUpward(context, componentName) {
  let parent = context.$parent;
  let name = parent.$options.name;

  while (parent && (!name || [componentName].indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }
  return parent;
}



// WEBPACK FOOTER //
// ./src/common/utils/vueFindComponent/findComponentUpward.js